import React from "react";
import { CheckCircle2Icon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
type CTAButtonProps = {
  label: string;
  id?: string;
  showNote?: boolean;
  tone?: "light" | "dark";
  className?: string;
};
export function CTAButton({
  label,
  id,
  showNote = true,
  tone = "light",
  className = ""
}: CTAButtonProps) {
  return <div className={`mx-auto w-full max-w-xl ${className}`} data-id="element-28" data-mp="2fya5jbo88z58">
      <a id={id} href={CHECKOUT_URL} className="flex w-full items-center justify-center gap-3 rounded-2xl bg-coral px-5 py-5 text-center text-[17px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_12px_28px_-10px_rgba(201,81,47,0.75)] transition-[transform,background-color] duration-150 ease-out hover:bg-coral-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-coral/40 sm:text-xl" data-id="element-29" data-mp="2tyb5mowo42jn">
        <CheckCircle2Icon className="h-7 w-7 shrink-0" aria-hidden="true" data-id="element-30" data-mp="38oir7dhz21ok" />
        <span data-id="element-31" data-mp="38mfs83yucy7p">{label}</span>
      </a>
      {showNote && <p className={`mt-3 text-center text-sm leading-relaxed ${tone === "dark" ? "text-cream/80" : "text-ink/70"}`} data-id="element-32" data-mp="19a7vtu9gns5q">
          Instant Digital Access · One-Time Payment of <strong className={tone === "dark" ? "text-cream" : "text-ink"} data-id="element-33" data-mp="1i91qvg758ah6">$27</strong> · Lifetime Access · 7-Day Guarantee
        </p>}
    </div>;
}